export default {
	setBreadcrumb(state, value){
		state.breadcrumb = value;
	},
	setLoginMes(state, value){
		state.loginMes = value;
	},
	setLoginName(state, value){
		state.loginName = value;
	}
}
